import {Post, Get} from '../../libs/request'
import ws from '@/libs/websocket'
import API from '@/libs/request/api'
import Utils from '@/libs/utils'
import router from '../../router'
const state = {
  userInfo: null,
  isLoading: null,
  phoneCodeState: null,
  showLogin: false,
  openId: null,
  userCenter: null,
  isGetCoupon: null

}
const getters = {
  getUserInfo: state => state.userInfo,
  getPhoneCodeState: state => state.phoneCodeState,
  getShowLogin: state => state.showLogin,
  getOpenId: state => state.openId,
  getUserCenter: state => state.userCenter,
  getCoupon: state => state.isGetCoupon
}

const mutations = {
  setUserInfo (state, userInfo) {
    state.userInfo = userInfo
    if (userInfo != null) {
      state.showLogin = false
    }
  },
  setLoading (state, isLoading) {
    state.isLoading = isLoading
  },
  setPhoneCodeState (state, phoneCodeState) {
    state.phoneCodeState = phoneCodeState
  },
  setShowLogin (state, showLogin) {
    state.showLogin = showLogin
  },
  setOpenId (state, openId) {
    state.openId = openId
  },
  setUserCenter (state, userCenter) {
    state.userCenter = userCenter
  },
  setCoupon (state, isGetCoupon) {
    state.isGetCoupon = isGetCoupon
  }
}

const saveInfo = (commit, userInfo) => {
  if (!userInfo) return
  commit('setUserInfo', userInfo)
  ws.init(API.API_WEB_SOCKET + '/' + userInfo.id)
  // Toast('登录成功')
}

const actions = {

  login: function ({commit}, data) {
    commit('setLoading', true)
    Post.login(data).then((res) => {
      commit('setLoading', null)
      if (res) {
        saveInfo(commit, res.data)
        Get.getUserInfo().then((res) => {
          let data = res.data
          let user = {
            isMember: data.isMember
          }
          commit('setUserCenter', user)
        })
        if (res.data.unpaidOrderId) {
          router.push({name: 'TelDetail', params: {id: res.data.unpaidOrderId}})
        }
        if (Utils.isWxgzh()) {
          let rou = location.hash
          if (rou) {
            rou = rou.replace('#', '')
          }
          let url = API.API_WEIXIN_BIND_AUTHORIZE + '?callback=' + location.origin + location.pathname + '&state=' + res.data.token + '&router=' + decodeURIComponent(rou)
          location.href = url
        }
      }
    }).catch((res) => {
      commit('setLoading', null)
    })
  },

  oAuthLogin: function ({commit}, data) {
    commit('setLoading', true)
    Post.oAuthLogin(data).then((res) => {
      console.log(res)
      commit('setLoading', null)
      if (res) {
        res.data.token = data.authorizationToken
        saveInfo(commit, res.data)
        const { origin, pathname, hash } = location
        history.replaceState(null, null, origin + pathname + hash)
      }
    }).catch((res) => {
      commit('setLoading', null)
    })
  },

  sendPhoneCode ({commit}, data) {
    commit('setLoading', true)
    commit('phoneCodeState', null)
    Post.getPhoneCode(data).then((res) => {
      commit('setLoading', null)
      commit('phoneCodeState', true)
    }).catch((res) => {
      commit('setLoading', null)
    })
  },
  requestOpenId ({commit}, data) {
    Post.getOpenId(data).then((res) => {
      if (res && res.data) {
        let data = res.data || {}
        if (data.openId) {
          commit('setOpenId', data.openId)
        }
        if (data.token) {
          saveInfo(commit, data)
        }
      }
    })
  },
  getUser ({commit}, data) {
    Get.getUserInfo(data).then((res) => {
      let info = res.data
      let user = {
        isMember: info.isMember
      }
      commit('setUserCenter', user)
    })
  }

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}

export {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js